import React, { Suspense, Fragment, lazy } from 'react';
import { Switch, Redirect, Route } from 'react-router-dom';
import DashboardLayout from 'src/layouts/DashboardLayout';
import MainLayout from 'src/layouts/MainLayout';
import HomeView from './views/home/HomeView';
import LoadingScreen from 'src/components/elements/LoadingScreen';
import LoginGuard from 'src/components/Guards/LoginGuard';
import IndexGuard from 'src/components/Guards/IndexGuard';
import AdminGuard from './components/Guards/AdminGuard';
import AdminRecintoGuard from './components/Guards/AdminRecintoGuard';

export const renderRoutes = (routes = []) => (
  <Suspense fallback={<LoadingScreen />}>
    <Switch>
      {routes.map((route, i) => {
        const Guard = route.guard || Fragment;
        const Layout = route.layout || Fragment;
        const Component = route.component;

        return (
          <Route
            key={i}
            path={route.path}
            exact={route.exact}
            render={props => (
              <Guard>
                <Layout>
                  {route.routes ? (
                    renderRoutes(route.routes)
                  ) : (
                    <Component {...props} />
                  )}
                </Layout>
              </Guard>
            )}
          />
        );
      })}
    </Switch>
  </Suspense>
);

const routes = [
  {
    exact: true,
    path: '/404',
    component: lazy(() => import('src/views/errors/NotFoundView'))
  },
  {
    exact: true,
    path: '/testRecuperarContrasena',
    component: lazy(() => import('src/views/auth/recuperacion_contrasena.js'))
  },
  {
    exact: true,
    guard: LoginGuard,
    path: '/login',
    component: lazy(() => import('src/views/auth/Login.js'))
  },
  {
    exact: true,
    guard: LoginGuard,
    path: '/register',
    component: lazy(() => import('src/views/auth/Register.js'))
  },
  {
    exact: true,
    guard: LoginGuard,
    path: '/activate-account',
    component: lazy(() => import('src/views/auth/ActivateAccount.js'))
  },
  {
    exact: true,
    guard: LoginGuard,
    path: '/recover-password',
    component: lazy(() => import('src/views/auth/RecoverPassword.js'))
  },
  {
    exact: true,
    guard: LoginGuard,
    path: '/send-email-recover-password',
    component: lazy(() => import('src/views/auth/recuperacion_contrasena.js'))
//    component: lazy(() => import('src/views/auth/SendRecoverPasswordEmail.js'))
  },
  {
    path: '/admin',
    guard: AdminGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/admin/recintos',
        component: lazy(() => import('src/views/admin/recintos/HomeRecintos'))
      },
      {
        exact: true,
        path: '/admin/mantenedores',
        component: lazy(() =>
          import('src/views/admin/mantenedores/HomeMantenedores')
        )
      },
      {
        exact: true,
        path: '/admin/usuarios',
        component: lazy(() => import('src/views/admin/users/HomeUsers'))
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '/admin-recinto',
    guard: AdminRecintoGuard,
    layout: DashboardLayout,
    routes: [
      {
        exact: true,
        path: '/admin-recinto/recintos/:recintoId',
        component: lazy(() =>
          import('src/views/adminRecinto/recintos/HomeRecintosDetail')
        )
      },
      {
        exact: true,
        path: '/admin-recinto/recintos/:recintoId/procedimientos',
        component: lazy(() =>
          import('src/views/adminRecinto/procedimientos/HomeProcedimientos')
        )
      },
      {
        exact: true,
        path: '/admin-recinto/recintos/:recintoId/horarios',
        component: lazy(() =>
          import('src/views/adminRecinto/recintos/DetalleAgendaSemanal')
        )
      },
      {
        exact: true,
        path: '/admin-recinto/recintos/:recintoId/canchas',
        component: lazy(() =>
          import('src/views/adminRecinto/canchas/HomeCanchas')
        )
      },
      {
        exact: true,
        path: '/admin-recinto/recintos/:recintoId/canchas/:canchaId',
        component: lazy(() =>
          import('src/views/adminRecinto/canchas/HomeCanchasDetail')
        )
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  },
  {
    path: '*',
    layout: MainLayout,
    routes: [
      {
        exact: true,
        path: '/',
        guard: IndexGuard,
        component: HomeView
      },
      {
        component: () => <Redirect to="/404" />
      }
    ]
  }
  // {
  //   path: '/app',
  //   layout: DashboardLayout,
  //   routes: [
  //     {
  //       exact: true,
  //       path: '/app/account',
  //       component: lazy(() => import('src/views/account/AccountView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/calendar',
  //       component: lazy(() => import('src/views/calendar/CalendarView'))
  //     },
  //     {
  //       exact: true,
  //       path: ['/app/chat/new', '/app/chat/:threadKey'],
  //       component: lazy(() => import('src/views/chat/ChatView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/chat',
  //       component: () => <Redirect to="/app/chat/new" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app/extra/charts/apex',
  //       component: lazy(() => import('src/views/extra/charts/ApexChartsView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/extra/forms/formik',
  //       component: lazy(() => import('src/views/extra/forms/FormikView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/extra/forms/redux',
  //       component: lazy(() => import('src/views/extra/forms/ReduxFormView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/extra/editors/draft-js',
  //       component: lazy(() => import('src/views/extra/editors/DraftEditorView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/extra/editors/quill',
  //       component: lazy(() => import('src/views/extra/editors/QuillEditorView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/kanban',
  //       component: lazy(() => import('src/views/kanban/KanbanView'))
  //     },
  //     {
  //       exact: true,
  //       path: [
  //         '/app/mail/label/:customLabel/:mailId?',
  //         '/app/mail/:systemLabel/:mailId?'
  //       ],
  //       component: lazy(() => import('src/views/mail/MailView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/mail',
  //       component: () => <Redirect to="/app/mail/all" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/customers',
  //       component: lazy(() => import('src/views/customer/CustomerListView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/customers/:customerId',
  //       component: lazy(() => import('src/views/customer/CustomerDetailsView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/customers/:customerId/edit',
  //       component: lazy(() => import('src/views/customer/CustomerEditView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/invoices',
  //       component: lazy(() => import('src/views/invoice/InvoiceListView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/invoices/:invoiceId',
  //       component: lazy(() => import('src/views/invoice/InvoiceDetailsView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/orders',
  //       component: lazy(() => import('src/views/order/OrderListView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/orders/:orderId',
  //       component: lazy(() => import('src/views/order/OrderDetailsView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/products',
  //       component: lazy(() => import('src/views/product/ProductListView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management/products/create',
  //       component: lazy(() => import('src/views/product/ProductCreateView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/management',
  //       component: () => <Redirect to="/app/management/customers" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app/projects/overview',
  //       component: lazy(() => import('src/views/project/OverviewView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/projects/browse',
  //       component: lazy(() => import('src/views/project/ProjectBrowseView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/projects/create',
  //       component: lazy(() => import('src/views/project/ProjectCreateView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/projects/:id',
  //       component: lazy(() => import('src/views/project/ProjectDetailsView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/projects',
  //       component: () => <Redirect to="/app/projects/browse" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app/reports/dashboard',
  //       component: lazy(() => import('src/views/reports/DashboardView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/reports/dashboard-alternative',
  //       component: lazy(() =>
  //         import('src/views/reports/DashboardAlternativeView')
  //       )
  //     },
  //     {
  //       exact: true,
  //       path: '/app/reports',
  //       component: () => <Redirect to="/app/reports/dashboard" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app/social/feed',
  //       component: lazy(() => import('src/views/social/FeedView'))
  //     },
  //     {
  //       exact: true,
  //       path: '/app/social/profile',
  //       component: lazy(() => import('src/views/social/ProfileView'))
  //     },import AdminRecintoGuard from 'alet-backoffice-client\src\components\Guards\AdminRecintoGuard';

  //     {
  //       exact: true,
  //       path: '/app/social',
  //       component: () => <Redirect to="/app/social/profile" />
  //     },
  //     {
  //       exact: true,
  //       path: '/app',
  //       component: () => <Redirect to="/app/reports/dashboard" />
  //     },
  //     {
  //       component: () => <Redirect to="/404" />
  //     }
  //   ]
  // },
];

export default routes;
